import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader/root';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Map, Pane } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import Loader from './Loader';
import IntroAnimation from './map-layers/IntroAnimation';
import ChoroplethLayer from './map-layers/Choropleth';
import DrawLayer from './map-layers/Draw';
import ValueDisplay from './map-layers/ValueDisplay';
import Tooltip from './map-layers/Tooltip';
import Legend from '../Legend';
import config from '~/scripts/config';
import Labels from './map-layers/Labels';
import KreisSearch from './map-layers/KreisSearch';

import * as S from './MapDrawer.styles';

const MapDrawer = () => {
  const loadData = useStoreActions((actions) => actions.app.loadData);
  const isDrawingEnabled = useStoreState((state) => state.app.isDrawingEnabled);
  const kreiseGeoJson = useStoreState((state) => state.app.kreiseGeoJson);
  const outlineGeoJson = useStoreState((state) => state.app.outlineGeoJson);
  const statesGeoJson = useStoreState((state) => state.app.statesGeoJson);
  const dataLoading = useStoreState((state) => state.app.dataLoading);
  const resultData = useStoreState((state) => state.app.resultData);

  useEffect(() => {
    loadData();
  }, []);

  if (dataLoading) {
    return <Loader />;
  }

  const padding =
    typeof window !== 'undefined' && window.innerWidth < 960
      ? [20, 20]
      : [20, 20];

  return (
    <S.MapDrawerOuter isDrawingEnabled={isDrawingEnabled}>
      <KreisSearch />
      <S.MapDrawerInner>
        <Map
          id="map"
          minZoom={0}
          maxZoom={20}
          zoomSnap={0.25}
          zoomDelta={0.25}
          zoomControl={false}
          dragging={false}
          scrollWheelZoom={false}
          doubleClickZoom={false}
          touchZoom={false}
          boxZoom={false}
          keyboard={false}
          bounds={L.geoJSON(kreiseGeoJson).getBounds()}
          boundsOptions={{ padding }}
        >
          <Pane>
            <ChoroplethLayer data={resultData} initialData={kreiseGeoJson} />
          </Pane>
          <Pane>
            {!resultData && (
              <DrawLayer outline={outlineGeoJson} states={statesGeoJson} />
            )}
          </Pane>
          {isDrawingEnabled && <Labels data={config.mapLabels} />}
          <ValueDisplay data={resultData} />
          <Tooltip />
          {isDrawingEnabled && <IntroAnimation />}
        </Map>
        {!!resultData && <Legend />}
      </S.MapDrawerInner>
    </S.MapDrawerOuter>
  );
};

export default hot(MapDrawer);
